import React from 'react'
import { RenderFormControl } from '../../FormControls/RenderFormControl'

export function NumberRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id },
  component,
  uid,
  setPage,
}) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach((row) => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    if (_.isNaN(min)) {
      min = '0'
    }
    if (_.isNaN(max)) {
      max = '0'
    }
    return [min, max]
  }, [id, preFilteredRows])

  let minPlaceholder = component.getIn(['props', 'captions', 'Min'], 'Min')
  let maxPlaceholder = component.getIn(['props', 'captions', 'Max'], 'Max')
  let toText = component.getIn(['props', 'captions', 'to'], 'to')

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}>
      <RenderFormControl
        value={filterValue[0] || ''}
        type="number"
        onChange={(e) => {
          const val = e.target.value
          setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
          if (e.target.value) {
            setPage(0)
          }
        }}
        placeholder={`${minPlaceholder} (${min})`}
        style={{
          width: '70px',
          marginRight: '0.5rem',
        }}
        themeKey="PrjPowerTableFilterField"
        styleKey={`ft--${uid}`}
      />
      {toText}
      <RenderFormControl
        value={filterValue[1] || ''}
        type="number"
        onChange={(e) => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
          if (e.target.value) {
            setPage(0)
          }
        }}
        placeholder={`${maxPlaceholder} (${max})`}
        style={{
          width: '70px',
          marginLeft: '0.5rem',
        }}
        themeKey="PrjPowerTableFilterField"
        styleKey={`ft--${uid}`}
      />
    </div>
  )
}
